import { rtdbPlugin as VueFire } from 'vuefire'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/firestore'

const config = {
  apiKey: process.env.FIRE_API_KEY,
  authDomain: process.env.FIRE_AUTH_DOMAIN,
  databaseURL: process.env.FIRE_DATABASE_URL,
  projectId: process.env.FIRE_PROJECT_ID,
  storageBucket: process.env.FIRE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIRE_MESSAGING_SENDER_ID
}

export const fireApp = firebase.initializeApp(config)
export const db = fireApp.firestore()

export default ({ app, router, Vue }) => {
  Vue.use(VueFire)
  Vue.use(firestorePlugin)
}
